import { 
  Home,         // ホーム
  Gavel,        // 入札
  FileText,     // 結果・書類
  Layers,       // 出品・在庫
  Database,     // マスタ・DB
  Users        // ユーザー
} from 'lucide-react'; //アイコン系
//ユーザー定義インポート
import { UserRole } from '../types/UserRole';
import { UserPermission } from '../types/UserPermission';

// === 1. 型定義 ===
// サブロール（詳細な権限範囲）
// market_sys: 管理者, market_op: 運営スタッフ, market_view: 参照, market_none: 権限なし
//export type AdminSubRole = 'market_sys' | 'market_op' | 'market_view' | 'market_none';

export interface AppUser {
  Id: string;
  UserName: string;
  role: UserRole;
  permission?: UserPermission;
}

export interface MenuItem {
  name: string;
  path: string;
  roles: (UserRole | 'all')[]; 
  permissions?: UserPermission[];
}

export interface MenuCategory {
  category: string;
  icon: any; 
  items: MenuItem[];
}

// === 2. 設定データ ===
export const MENU_CONFIG: MenuCategory[] = [
  // --- ホーム ---
  {
    category: "ホーム",
    icon: Home,
    items: [
      { name: "メニュー画面", path: "/", roles: ["all"] },
    ]
  },

  // --- 出品管理 ---
  {
    category: "出品管理",
    icon: Layers,
    items: [

      { name: "出品情報の一括登録", path: "/itemBulkUpload", roles: [UserRole.Farmer, UserRole.Seller, UserRole.JA, UserRole.Admin] },

      { name: "出品情報の編集", path: "/maintenance", roles: [UserRole.Farmer, UserRole.Seller, UserRole.JA, UserRole.Admin] },

      // ステータス変更機能
      { name: "出品情報の状態確認", path: "/updatestatus-eachuser", roles: [UserRole.Farmer] },
      { name: "出品情報の提出", path: "/updatestatus-eachuser", roles: [UserRole.JA, UserRole.Seller] },
      { name: "出品情報の確定", path: "/updatestatus-eachuser", roles: [UserRole.Admin] },

      { name: "最低落札値の決定", path: "/bid-min-price-setting", roles: [UserRole.JA, UserRole.Seller, UserRole.Admin] },
      
      // 管理者専用機能
      { name: "出品一覧表印刷", path: "/admin/print-list", roles: [UserRole.Admin] },
      { name: "手合票印刷", path: "/admin/print-deal", roles: [UserRole.Admin] },
    ]
  },

  // --- 入札管理 ---
  {
    category: "入札管理",
    icon: Gavel,
    items: [
      // 買い手用
      { name: "出品予定の確認", path: "/listing-schedule", roles: [UserRole.Buyer] },
      { name: "かんたん入札", path: "/buyer/input-number", roles: [UserRole.Buyer] },
      { name: "一覧から入札", path: "/buyer/input", roles: [UserRole.Buyer] },
      
      // 管理者用
      { name: "入札スケジュール管理", path: "/bidding-schedule", roles: [UserRole.Admin] },
      { name: "入札Noの手動採番", path: "/admin/manual-numbering", roles: [UserRole.Admin] },
      { name: "入札状況確認", path: "/admin/bidding-monitor", roles: [UserRole.Admin], permissions: [UserPermission.Admin, UserPermission.Creator] },
      { name: "落札確定機能", path: "/admin/bid-confirmation", roles: [UserRole.Admin], permissions: [UserPermission.Admin, UserPermission.Creator]  },
      { name: "連携用CSV再出力", path: "/admin/csv-reexport", roles: [UserRole.Admin], permissions: [UserPermission.Admin, UserPermission.Creator]  },
    ]
  },

  // --- 確認・帳票 ---
  {
    category: "確認機能",
    icon: FileText,
    items: [
      { name: "落札結果の確認", path: "/results", roles: [UserRole.JA, UserRole.Farmer, UserRole.Seller, UserRole.Buyer, UserRole.Admin] },
      // 管理者用
      // { name: "落札結果確認機能(公開用)", path: "/admin/inquiry/win-results", roles: [UserRole.Admin] },
      { name: "落札結果一覧表(公開用)", path: "/admin/inquiry/win-list", roles: [UserRole.Admin] },
      
      // 共通
      { name: "入札スケジュール確認", path: "/bidding-schedule", roles: [UserRole.JA, UserRole.Seller, UserRole.Farmer, UserRole.Buyer] },
    ]
  },

  // --- マスタ管理 ---
  {
    category: "マスタ管理",
    icon: Database,
    items: [
      // { name: "システムマスタメンテ機能", path: "/admin/master/system", roles: [UserRole.Admin] },
      // { name: "汎用マスタメンテ機能", path: "/admin/master/general", roles: [UserRole.Admin] },
      // { name: "基幹マスタ連携", path: "/admin/master/core-sync", roles: [UserRole.Admin] },
      { name: "マスタ確認機能", path: "/admin/masters", roles: [UserRole.Admin] },
      { name: "お知らせ管理", path: "/admin/notice-management", roles: [UserRole.Admin] },
    ]
  },

  // --- ユーザー管理 ---
  {
    category: "ユーザー管理",
    icon: Users,
    items: [
      { name: "ユーザーメンテ機能", path: "/admin/users/maintenance", roles: [UserRole.Admin] },
      // { name: "ユーザー情報出力", path: "/admin/users/export", roles: [UserRole.Admin] },
      // { name: "市場ユーザー権限管理機能", path: "/admin/users/permissions", roles: [UserRole.Admin] },
    ]
  },
];